<template>
  <div class="gift-information__container white-back-container">
    <div class="white-back-container__content">
      <div class="gift-information__header white-back-container__header">
        <h3 class="subhead-bold">
          お届けするギフト
        </h3>
      </div>
      <div class="white-back-container__inner-content">
        <TicketConnected
          :image-url="imageUrl"
          :item-name="itemName"
          :item-sku-name="itemSkuName"
          :brand-name="brandName"
          :expired-date="`住所入力期限：${expiredDate}まで`"
          :show-expired-date-notice="true"
        />
      </div>
      <TextLinkListExpand
        text="ギフト詳細と仕様・注意事項"
        class="description-html-text-link-list-expand"
      >
        <div class="description-html-text-link-list-expand__body">
          <KittyHtmlSanitized :html="descriptionHtml" />
          <SmallLoading v-if="isLoadingTicketDescriptionHtml" />
        </div>
      </TextLinkListExpand>
    </div>
  </div>
</template>

<script>
import KittyHtmlSanitized from '../../../../atoms/html/KittyHtmlSanitized.vue'
import TicketConnected from '../../../../atoms/tickets/TicketConnected.vue'
import SmallLoading from '../../../../atoms/loadings/SmallLoading.vue'
import TextLinkListExpand from '../../../../molecules/text_link_lists/TextLinkListExpand.vue'
export default {
  components: {
    KittyHtmlSanitized,
    SmallLoading,
    TicketConnected,
    TextLinkListExpand
  },
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: true
    },
    brandName: {
      type: String,
      required: true
    },
    expiredDate: {
      type: String,
      required: true
    },
    descriptionHtml: {
      type: String,
      required: true
    },
    isLoadingTicketDescriptionHtml: {
      type: Boolean,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.description-html-text-link-list-expand {
  border-top: solid 1px $gray-2;

  &__body {
    padding: 16px;
  }
}

:deep(.text-link-list-expand__header) {
  padding: 16px;
}
</style>
